import {
	DistrictDto,
	PageDto,
	SearchFilter,
	PageOptionsDto,
	CreateDistrictDto,
	UpdateDistrictDto,
} from '@families-link/shared';
import api from '.';

const districtsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getDistrictListPagination: builder.query<PageDto<DistrictDto>, PageOptionsDto & SearchFilter>({
			query: ({ page, take, orderField, order, search }) => ({
				url: `districts`,
				params: { page, take, orderField, order, search },
			}),
			providesTags: ['District'],
		}),
		getDistrictList: builder.query<DistrictDto[], void>({
			query: () => ({
				url: `districts/all`,
			}),
			providesTags: ['District'],
		}),
		getDistrict: builder.query<DistrictDto, { id?: string | null }>({
			query: ({ id }) => ({
				url: `districts/${id}`,
			}),
			providesTags: ['District', 'Engagement'],
		}),
		getLinguistLinkDistrictList: builder.query<{ _id: string; company: string }[], void>({
			query: () => ({
				url: `districts/linguist-link/all`,
			}),
		}),
		// getDistrictWithoutInitiate: builder.query<DistrictDto, { id?: string | null }>({
		// 	query: ({ id }) => ({
		// 		url: `districts/${id}/without-initiate`,
		// 	}),
		// }),
		createDistrict: builder.mutation<DistrictDto, CreateDistrictDto>({
			query: (data) => ({
				url: `districts`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['District'],
		}),
		updateDistrict: builder.mutation<DistrictDto, { id: string; data: UpdateDistrictDto }>({
			query: ({ id, data }) => ({
				url: `districts/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['District'],
		}),
		deleteDistrict: builder.mutation<DistrictDto, { id: string }>({
			query: ({ id }) => ({
				url: `districts/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['District'],
		}),
	}),
});

export default districtsApi;

export const {
	useGetDistrictListPaginationQuery,
	useGetDistrictQuery,
	useGetDistrictListQuery,
	useGetLinguistLinkDistrictListQuery,
	useCreateDistrictMutation,
	useUpdateDistrictMutation,
	useDeleteDistrictMutation,
	// useGetDistrictWithoutInitiateQuery,
} = districtsApi;
